export const registerCreditNoteLineSelector = (Alpine) => {
    Alpine.data("creditNoteLineSelector", ({ lines = [] } = {}) => ({
        lines,
        selectedLineIds: [],
        rules: {},

        availableLines() {
            return this.lines.filter((line) => !line.added);
        },

        selectedLines() {
            return this.lines.filter((line) =>
                this.selectedLineIds.includes(line.id),
            );
        },

        selectedTypes() {
            const selectedTypes = new Map();

            this.selectedLines().forEach((line) => {
                if (!selectedTypes.has(line.type)) {
                    selectedTypes.set(line.type, {
                        type: line.type,
                        label: line.type_label,
                    });
                }
            });

            this.syncRules();

            return Array.from(selectedTypes.values());
        },

        selectedCountForType(type) {
            return this.selectedLines().filter((line) => line.type === type)
                .length;
        },

        allAvailableSelected() {
            const availableLineIds = this.availableLines().map(
                (line) => line.id,
            );

            return (
                availableLineIds.length > 0 &&
                availableLineIds.every((lineId) =>
                    this.selectedLineIds.includes(lineId),
                )
            );
        },

        toggleAllAvailable() {
            if (this.allAvailableSelected()) {
                this.selectedLineIds = [];
            } else {
                this.selectedLineIds = this.availableLines().map(
                    (line) => line.id,
                );
            }

            this.syncRules();
        },

        syncRules() {
            const selectedTypes = new Set(
                this.selectedLines().map((line) => line.type),
            );

            Object.keys(this.rules).forEach((type) => {
                if (!selectedTypes.has(type)) {
                    delete this.rules[type];
                }
            });

            selectedTypes.forEach((type) => {
                this.rules[type] = this.rules[type] ?? {
                    mode: "percent",
                    percent: "",
                    amount: "",
                };
            });
        },
    }));
};
